import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'redondear'
})
export class RedondearPipe implements PipeTransform {

  transform(valor: number, args1: number): any {

    if (valor === 0) {
      return 'radial-bar-0';
    }

    const value = ((valor / args1) * 100);


    const valorReturn = (valor % 5 < 3) ? (value % 5 === 0 ? value : Math.floor(value / 5) * 5) : Math.ceil(value / 5) * 5;

    const a = 'radial-bar-' + valorReturn;

    return a;

  }
}
